import { useEffect, useRef, useState } from 'react';
import { useCMS } from '@/hooks/useCMS';

const DEFAULT = {
  label: 'პარტნიორები',
  heading: 'ბრენდები',
  description: 'ვართ მსოფლიოს წამყვანი სამშენებლო მასალების ბრენდების ოფიციალური დისტრიბუტორი საქართველოში.',
  brands: [
    { name: 'Laminam',  origin: 'იტალია',   specialty: 'კერამიკული ფილები' },
    { name: 'Ardex',    origin: 'გერმანია',  specialty: 'სამშენებლო ქიმია' },
    { name: 'Tecnopol', origin: 'ესპანეთი', specialty: 'ჰიდროიზოლაცია' },
    { name: 'Fodbo',    origin: 'დანია',     specialty: 'იატაკი' },
    { name: 'Dicson',   origin: 'გერმანია',  specialty: 'იატაკი' },
    { name: 'Antolini', origin: 'იტალია',   specialty: 'ბუნებრივი ქვა' },
  ],
};

export default function BrandsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [hovered, setHovered] = useState<number | null>(null);
  const d = useCMS('brands_section', DEFAULT);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('animate-fade-up'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#F5F2EE] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-8 md:px-14">
        <div className="reveal opacity-0 flex items-end justify-between mb-16 border-b border-[#1C1C1C]/8 pb-8">
          <div>
            <span className="text-[10px] font-bold tracking-[0.35em] uppercase text-[#ec3145] block mb-3">{d.label}</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1C1C1C]">{d.heading}</h2>
          </div>
          <p className="hidden md:block text-sm text-[#1C1C1C]/40 max-w-xs text-right leading-relaxed">{d.description}</p>
        </div>
        <div className="reveal opacity-0">
          {(d.brands || []).map((brand: any, i: number) => (
            <div key={i} className="group flex items-center justify-between py-6 border-b border-[#1C1C1C]/8 cursor-pointer" onMouseEnter={() => setHovered(i)} onMouseLeave={() => setHovered(null)}>
              <div className="flex items-center gap-8">
                <span className="text-[10px] font-bold tracking-[0.3em] text-[#1C1C1C]/20 w-5">{String(i + 1).padStart(2, '0')}</span>
                <h3 className={`font-serif text-3xl md:text-5xl font-bold transition-colors duration-300 ${hovered === i ? 'text-[#ec3145]' : 'text-[#1C1C1C]'}`}>{brand.name}</h3>
              </div>
              <div className="flex items-center gap-8">
                <span className={`text-[10px] font-bold tracking-[0.25em] uppercase transition-colors duration-300 hidden sm:block ${hovered === i ? 'text-[#ec3145]' : 'text-[#1C1C1C]/30'}`}>{brand.specialty}</span>
                <span className={`text-[10px] font-bold tracking-[0.25em] uppercase transition-colors duration-300 hidden md:block ${hovered === i ? 'text-[#1C1C1C]/50' : 'text-[#1C1C1C]/20'}`}>{brand.origin}</span>
                <i className={`ri-arrow-right-up-line text-lg transition-all duration-300 ${hovered === i ? 'text-[#ec3145] translate-x-1 -translate-y-1' : 'text-[#1C1C1C]/20'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
